import React from "react"
import { Link } from "gatsby"
import { GatsbySeo } from "gatsby-plugin-next-seo"

import Layout from "../components/layout"
import Hero from "../components/Hero/Hero"
import ParallaxCard from "../components/ParallaxCard"
import AboutUs from "../components/AboutUs"
import Card from "../components/Card"
import Header from "../components/header"

import Restaurant from "../images/hero/restaurant.jpg"
import RestaurantTwo from "../images/hero/Restaurant3.jpg"
import Popup from "../components/Popup/Popup"

const HomePage = () => {
  return (
    <>
      <GatsbySeo
        title="SitLo Saigon "
        description="best pho, best pho elk grove, best pho davis, best pho sacramento, Best pho in Elk Grove, best pho in Sacramento county, Vietnamese, pho, noodles, broth and meat."
        canonical="/"
      />
      <Layout homeNav>
        <h1 className="hidden-text">best pho in elk grove, best pho elk grove, best pho</h1>
        {/* <Popup/> */}
        <Hero />
        <AboutUs />
        <section aria-label="Menu Preview">
          <ParallaxCard
            image={RestaurantTwo}
            alt="Sit Lo Saigon Restaurant Interior"
            height="100vh"
            children={
              <div className="parallax-content">
                <div className="parallax-text-block">
                  <Link to="/menu">
                    <h2>
                      Explore our <span>menu</span>
                    </h2>
                  </Link>
                </div>
              </div>
            }
          />
        </section>
        <section aria-label="Gallery Preview">
          <ParallaxCard
            image={Restaurant}
            alt="Sit Lo Saigon Dining Area"
            height="100vh"
            children={
              <div className="parallax-content">
                <div className="parallax-text-block">
                  <Link to="/gallery">
                    <h2>
                      View our <span>gallery</span>
                    </h2>
                  </Link>
                </div>
              </div>
            }
          />
        </section>
      </Layout>
    </>
  )
}

export default HomePage
